import instance from '../axios'

// Browse history: signed-in only. Views power the "Recently viewed" rail and,
// later, personalization. The server upserts one row per title and respects
// the Settings opt-out, so callers can fire-and-forget.
//
// Every call takes the token explicitly (like user-media-api) instead of
// relying on the axios interceptor: these fire on page mount, and the
// interceptor's token getter may not be registered yet at that moment. An
// unauthenticated 401 here would trigger the global session-expired redirect.

export type RecentView = {
  tmdbId: number
  mediaType: 'Movie' | 'Show' | string
  title: string
  posterPath?: string | null
  releaseYear?: number | null
  genres: string[]
  lastViewedOnUtc: string
}

export type RecordViewPayload = {
  mediaType: 'Movie' | 'Show'
  tmdbMediaId: number
  title: string
  posterPath?: string
  releaseYear?: number
  genresJson?: string
}

const withAuth = (token: string) => ({
  headers: { Authorization: `Bearer ${token}` },
})

const browseHistoryApi = {
  recordView: (payload: RecordViewPayload, token: string) =>
    instance.post('/browse-history', payload, withAuth(token)),

  getRecent: (count: number, token: string) =>
    instance.get<RecentView[]>(`/browse-history/recent?count=${count}`, withAuth(token)),

  // mediaType uses the server-side casing: "Movie" | "Show".
  removeItem: (mediaType: string, tmdbId: number, token: string) =>
    instance.delete(`/browse-history/${mediaType}/${tmdbId}`, withAuth(token)),

  clear: (token: string) => instance.delete('/browse-history', withAuth(token)),
}

export default browseHistoryApi
